<div class="cv-dropdown-component wrapper">
	<label *ngIf="label && label.length > 0">
		{{label}} <span class="required-text" *ngIf="required">*</span>
	</label>
	<button #dropdownButton
		class="btn btn-outline-secondary __select"
		[ngClass]="{
			'--open': isOpen, 
			'input-invalid': (!isValid() || !valid)
		}"
		[attr.disabled]="disabled ? 'disabled' : null"
		[ngStyle]="{ width: width }"
		(click)="toggleMenu()">
		<a class="__clear-button"
			javascript="void(0);"
			(click)="clearValues($event)"
			*ngIf="selectedOptionText">
			<i class="fa fa-times"></i>
		</a>
		<span class="title_lbl item-value" 
			[ngClass]="{
				'__text': selectedOptionText,
				'__placeholder': !selectedOptionText
			}">
			{{ selectedOptionText || placeholder }}
		</span>
		<i class="{{icon ? icon : ''}} fa __icon"
			 [ngClass]="{'fa-caret-down': !isOpen && !icon, 'fa-caret-up': isOpen && !icon}">
		</i>
	</button>
	<span class="cv-test action-clear" (click)="clearValues()"></span>
	<span class="cv-test action-toggle"></span>
	<div #dropdownMenu 
		class="dropdown-menu cv-dropdown-menu"
		[ngStyle]="{ width: width }">

		<div *ngFor="let option of options; let optionIndex = index">
			<a class="dropdown-item __option action-select"
				[ngClass]="{'__selected': isOptionSelected(optionIndex)}"
				(click)="selectOption(option, optionIndex)">
				<span class="item-value">{{ option[optionText] || option }}</span>
			</a>
		</div>
	</div>

</div>
